module.exports = __webpack_public_path__ + "img/logo-drs2.2a56a60f.png";